import * as S from "components/common/Banner/Overlay.style";

const OverlayMobile = () => {
    return(
        <>
            <S.Overlay>
                <S.TextBanner variant="headline-01" color="white">
                    <S.MainInfo>
                        Documentos, relatórios e
                    </S.MainInfo>
                    <S.MainInfo>
                        conhecimento que transforma
                    </S.MainInfo>
                </S.TextBanner>
                <S.TextBanner variant="headline-01" color="white">
                    <S.SecondaryInfo>
                        Consulte nossas publicações
                    </S.SecondaryInfo>
                </S.TextBanner>
                <S.BannerIndicator />
            </S.Overlay>
        </>
    );
};
export default OverlayMobile;